import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { exchangeService } from '../services/exchange.service';
import { ISearchProps } from './app-header/app-header';
import { DatePicker } from './date-picker';
import { MobileBottomBar } from './mobile-bottom-bar';
import SearchRegions from './search-regions';

export function MobileSearchForm(props: ISearchProps) {
  const { t } = useTranslation();
  const { activeModule, onChangeModule, searchBy, handleFormSubmit, onSetSearchBy } = props;
  const formatDate = (date: Date): string => {
    return moment(date).format('MMM D');
  };
  const modules: { [key: string]: { [key: string]: string | number } } = {
    location: {
      title: t('mobile-search-form-location-title'),
      value:
        searchBy.city && searchBy.state
          ? `${searchBy.city}, ${searchBy.state}`
          : searchBy.state
            ? searchBy.state
            : searchBy.city
              ? searchBy.city
              : t('mobile-search-form-location-flexible'),
    },
    startDate: {
      title: t('mobile-search-form-when-title'),
      value:
        searchBy.startDate && searchBy.endDate
          ? `${formatDate(searchBy.startDate)} - ${formatDate(searchBy.endDate)}`
          : t('mobile-search-form-when-add-dates'),
    },
  };

  return (
    <section className="mobile-search-form main-layout">
      <h1 className="title">{t('mobile-search-form-main-title')}</h1>
      {Object.keys(modules).map((module) => (
        <div
          key={module}
          className={`module-container ${
            activeModule === module || (activeModule === 'endDate' && module === 'startDate')
              ? 'active'
              : ''
          }`}
        >
          {activeModule === module || (activeModule === 'endDate' && module === 'startDate') ? (
            module === 'location' ? (
              <SearchRegions {...props} />
            ) : (
              <DatePicker {...props} numOfMonths={1} onApply={handleFormSubmit} />
            )
          ) : (
            <button
              onClick={() => onChangeModule(module)}
              className="module-tab flex align-center justify-between"
              type="button"
            >
              <span className="font-medium text-muted">{modules[module].title}</span>
              <span className="font-medium">{modules[module].value}</span>
            </button>
          )}
        </div>
      ))}
      <MobileBottomBar
        buttonText={t('mobile-search-form-button-search')}
        handleClick={handleFormSubmit}
      >
        <button
          onClick={() => onSetSearchBy(exchangeService.getDefaultSearch())}
          className="link"
          type="button"
        >
          {t('mobile-search-form-button-clear-all')}
        </button>
      </MobileBottomBar>
    </section>
  );
}
